import type { GlobalSearchResultItem } from 'models';
import { useTranslation } from 'react-i18next';

import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const EventItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();

  return (
    <SearchItemRow itemActionProps={itemActionProps}>
      <SearchItemContent
        subtitle={
          <>
            {t('dateFormats.dateTime', { date: itemProps.startTime })}
            {itemProps.place ? `, ${itemProps.place}` : null}
          </>
        }
        title={itemProps.name ?? ''}
      />
    </SearchItemRow>
  );
};

export default EventItem;
